import { html } from "lit";
import { state } from "lit/decorators.js";
import { DsfOption } from "../Option/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfOptionGroup = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.groupCount = "";
  }
  get optionElements() {
    var _a;
    const elements = ((_a = this.shadowRoot.querySelector("slot")) == null ? void 0 : _a.assignedElements()) || [
      ...this.children
    ];
    return elements.filter((el) => el instanceof DsfOption);
  }
  handleSlotChange() {
    const optionCount = this.optionElements.filter((o) => !o.hidden).length;
    this.groupCount = `${optionCount ? ` (${optionCount})` : ""}`;
  }
  render() {
    return html`<div class="flex flex-auto flex-col">
      <span class="dsf-text-xs px-12 py-4 text-neutral-300" data-skeleton
        >${this.dsf_title}${this.groupCount}</span
      >
      <div class="flex flex-auto flex-col">
        <slot @slotchange=${this.handleSlotChange}></slot>
      </div>
    </div>`;
  }
};
DsfOptionGroup.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
__decorateClass([
  prop({ type: String })
], DsfOptionGroup.prototype, "dsf_title", 2);
__decorateClass([
  state()
], DsfOptionGroup.prototype, "groupCount", 2);
DsfOptionGroup = __decorateClass([
  defineElement("dsf-option-group")
], DsfOptionGroup);
export {
  DsfOptionGroup
};
